import { render, staticRenderFns } from "./MoreImagesLink.vue?vue&type=template&id=afd82d66&"
import script from "./MoreImagesLink.vue?vue&type=script&lang=js&"
export * from "./MoreImagesLink.vue?vue&type=script&lang=js&"
import style0 from "./MoreImagesLink.vue?vue&type=style&index=0&id=afd82d66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports